import { usePolicyContext } from "../../Contexts/AddPolicyContext";
import Button from "../../Components/Button";
import React from "react";

function PolicySuccess() {
  const {
    setPersonalMaxicareNumber,
    setInitialAddPolicyData,
    setEmployeeNumber,
    setSelectedType,
    setCompanyCode,
    setBirthDate,
    navigate,
  } = usePolicyContext();

  const handleNav = (path) => {
    navigate(path, { replace: true });
    setInitialAddPolicyData(null);
    setSelectedType("");
    setPersonalMaxicareNumber("");
    setCompanyCode("");
    setEmployeeNumber("");
    setBirthDate(null);
  };

  return (
    <div className="flex flex-col items-center min-h-screen max-w-screen sm:bg-[#E7EEFA] cursor-default">
      <div className="bg-white w-screen mb-[56px] sm:my-24 sm:w-148 h-auto rounded-xl sm:justify-center">
        <div className="mt-52 sm:mt-0 flex flex-col items-center justify-center text-center px-6">
          <div className="flex justify-center mt-3">
            <img
              src={require("../../assets/success.png")}
              alt="Personal"
              className="w-24 h-24 flex justify-center"
            />
          </div>

          <div className="text-2xl text-center font-semibold">
            Policy successfully added!
          </div>

          <div className=" text-center my-1 mx-3 text-[#60656D]">
            Congratulations, your policy information has been added to your
            account.
          </div>

          <div className="bg-white flex-grow" />
          <div className="flex flex-col items-center sm:w-full justify-center absolute inset-x-0 bottom-0 sm:relative sm:mt-2 p-4">
            <Button
              className="w-full h-14 bg-white rounded-lg border font-semibold transition ease-in-out delay-75 hover:scale-105"
              onClick={() => handleNav("/add-policy/choose-membership")}
            >
              Add another Policy
            </Button>

            <Button
              className="w-full h-14 text-white bg-[#0947AB] rounded-lg font-semibold transition ease-in-out delay-75 hover:scale-105 mt-2 mb-4"
              onClick={() => handleNav("/home")}
            >
              Go to dashboard
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PolicySuccess;
